
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import AppProjectInfoGeneral from "./ProjectInfoGeneral.vue";
import AppCustomViewTabFrames from "@/components/browse/CustomViewTabFrames.vue";
import { DossierService } from "@/services/dossier-service";
import AppProjectEditExtraFields from "./ProjectEditExtraFields.vue";
import AppProjectInfoAwsDocuments from "./ProjectInfoAwsDocuments.vue";
import { Project } from "@/models/base";
import { UserConfigService } from "@/services/user-config-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";

export default Vue.extend({
	data() {
		return {
			activeTab: 0
		};
	},
	props: {
		project: {
			required: true,
			type: Object as () => Project
		},
		drawerButtonDisabled: Boolean
	},
	computed: {
		canEdit(): boolean {
			return UserConfigService.hasCurrentUserPermission((p) => p.getPermissionsByBrowseID(23).hasWritePermissions());
		},
		canDelete(): boolean {
			return UserConfigService.hasCurrentUserPermission((p) => p.getPermissionsByBrowseID(23).hasDeletePermissions());
		},
		defaultTabs(): DefaultEditTab[] {
			return getVisibleDefaultEditTabs(23);
		},
		currentTabKey(): string {
			return this.defaultTabs[this.activeTab]?.key || "";
		},
		tabs(): any {
			let t = this.defaultTabs.map(t=>t.label());
			let e = UserConfigService.getCustomViewTabs();
			let v = e.getTabNamesForBrowse(23);
			return [...t, ...v, ...this.extraFieldNamesConfig.getTabNames()];
		},
		customViewTabs(){
			return UserConfigService.getCustomViewTabsForBrowse(23);
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().ProjectNames;
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},
		extraFieldTabStart():number {
			return this.defaultTabs.length + this.customViewTabs.length;
		},
	},
	methods: {
		onUpdateParent(event: Project){
			this.$emit("update:project", new Project(event));
		},
		cancel() {
			this.$emit("close");
		},
		edit() {
			this.$emit("edit");
		}
	},
	async mounted() {
		// No title - consistent with edit view
	},
	async created(){
		await DossierService.getUsers();
	},
	components: {
		AppProjectEditExtraFields,
		AppProjectInfoAwsDocuments,
		AppProjectInfoGeneral,
		AppCustomViewTabFrames,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
